// About.js
import React from "react";
import Chef from "../assets/staff.jpg";
import { SectionLayout } from "./SectionLayout";

export const About = () => {
  return (
    <SectionLayout
      textLeft={false}
      title="Passionen Bakom Varje Rätt"
      text="Våra passionerade kockar ger liv åt sekler av italiensk mattradition. Varje rätt berättar en historia, och varje smak tar dig på en resa genom Italien. Vi brinner för att servera den bästa maten och skapa den mest genuina upplevelsen.
"
      image={Chef}
      altText="Vår passionerade kock"
      motionProps={{
        titleMotion: {
          whileInView: { x: 0, opacity: 1 },
          initial: { x: -20, opacity: 0 },
          viewport: { once: true, amount: 0.3 }, // Trigger animation when 30% is in view
          transition: { duration: 1 },
        },
        textMotion: {
          whileInView: { x: 0, opacity: 1 },
          initial: { x: -20, opacity: 0 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 1 },
        },
        imageMotion: {
          whileInView: { opacity: 1, scale: 1 },
          initial: { opacity: 0, scale: 0.8 },
          viewport: { once: true, amount: 0.3 },
          transition: { duration: 1 },
        },
      }}
    />
  );
};
